import React from "react";
import { cn } from "../../../lib/utils";

interface ToolCardProgressProps {
  value: number;
  label?: string;
}

export const ToolCardProgress: React.FC<ToolCardProgressProps> = ({ value, label }) => {
  const clampedValue = Math.min(100, Math.max(0, value));

  return (
    <div className="flex items-center gap-2 w-full">
      <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
        <div
          className={cn(
            "h-full rounded-full transition-all duration-150",
            clampedValue === 100 ? "bg-success" : "bg-primary"
          )}
          style={{ width: `${clampedValue}%` }}
        />
      </div>
      <span className="text-xs text-muted-foreground tabular-nums whitespace-nowrap">
        {label ?? `${Math.round(clampedValue)}%`}
      </span>
    </div>
  );
};
